import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, retry, finalize } from 'rxjs/operators';
//import { JwtService } from '../services/jwt.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../services/storage.service';

@Injectable()
export class HttpconfigInterceptor implements HttpInterceptor {

  constructor(
    private session: StorageService,
    private router: Router,
    private injector: Injector
  ) { }

  private get toastrService(): ToastrService {
    return this.injector.get(ToastrService);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const jwt = this.session.loggednUser?.token;
    if (!!jwt) {
      request = request.clone({
       setHeaders: {
         Authorization: `Bearer ${jwt}`
       }
     });
   }
   if (request.method==="GET"){
     request = request.clone({
      params:request.params
      .set('typetn', `${new Date()}`)
    });
   }

    return next.handle(request).pipe(
      retry(0),
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          console.log('event--->>>', event);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // if (error.status === 401) {
        //   // refresh token
        // }
        // else {
        //   return throwError(error);
        // }
        return throwError(error);
      }),
      finalize(() => {
        // hide loading spinner
        // this.loadingDialogService.hideDialog();
      })
    );

  }

}
